import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/')({
  preload: false,
  loader: ({ params }) => {
    throw redirect({ to: `/registration/account/$accountId/asset`, params: { accountId: params.accountId } });
  },
});
